'use client'

import React from 'react'
import { Clock, Infinity, AlertTriangle, CalendarDays } from 'lucide-react'
import { calculateOfferDuration } from '@/constants/hooks'

interface Props { endDate?: string | null }

const ExpiryTag = ({ endDate }: Props) => {
    // No end_date from backend — don't show anything
    if (!endDate) return null

    const label = calculateOfferDuration(endDate)

    if (label === 'Offer expired') return (
        <span className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-md"
            style={{ background: '#fee2e2', color: '#dc2626' }}>
            <AlertTriangle size={9} /> Expired
        </span>
    )

    if (label === 'Life Time') return (
        <span className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-md"
            style={{ background: '#E1F1F2', color: '#2CBBC3' }}>
            <Infinity size={9} /> Lifetime
        </span>
    )

    if (label === 'Last day') return (
        <span className="inline-flex items-center gap-1 text-[10px] font-black px-2 py-0.5 rounded-md"
            style={{ background: '#F8F246', color: '#8C5826' }}>
            <Clock size={9} /> Last Day!
        </span>
    )

    const days = label.match(/^(\d+)\s+day/)?.[1]
    const daysNum = days ? parseInt(days) : null
    const isUrgent = daysNum !== null && daysNum <= 3

    if (isUrgent) return (
        <span className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-md"
            style={{ background: '#fff3cd', color: '#8C5826' }}>
            <Clock size={9} /> {label}
        </span>
    )

    return (
        <span className="inline-flex items-center gap-1 text-[10px] font-medium px-2 py-0.5 rounded-md"
            style={{ background: '#E1F1F2', color: '#2CBBC3' }}>
            <CalendarDays size={9} /> {label}
        </span>
    )
}

export default ExpiryTag
